import * as yup from 'yup';

import { NOT_BLANK_REGEX } from 'utils/constants';

export const getValidationSchema = () =>
  yup.object().shape({
    /* eslint-disable no-template-curly-in-string */
    poNumber: yup
      .string()
      .max(50, 'PO Number is limited to ${max} characters')
      .when('$caseHasCost', (caseHasCost, schema) =>
        caseHasCost
          ? schema.matches(NOT_BLANK_REGEX, 'PO Number is mandatory.')
          : schema
      ),
  });
